<template>
  <div class="w-full flex items-center justify-center">
    <div class="warpper">
      <span class="text">{{ content.value }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Voiceover extends Vue {
  @Prop({ type: Object }) content!: Content & {
    value: string;
  };
}
</script>
<style scoped>
.warpper {
  @apply inline-block text-sm my-8 max-w-full ml-12 md:mr-12 mr-11;
}
@screen md {
  .warpper {
    max-width: 50% !important;
  }
}

.text {
  @apply inline-block rounded-motif;
  padding: 14px 18px;
  color: #666666;
  font-size: 15px;
  line-height: 24px;
  background: #f8f8fa;
}
</style>
